import { BackupRequestLookupsDTO } from "@/core/dto/deduction/remittance";
import { BackupRequestLookups } from "@/core/entities/deduction/remittance/BackupRequestLookups";
import { IBackupRequestRepository } from "@/core/repositories/remittance/backupRequest/IBackupRequest.repository";

export class GetBackupRequestUseCase {
  constructor(private readonly backupRequestRepository: IBackupRequestRepository) {}

  async execute(params: BackupRequestLookupsDTO): Promise<BackupRequestLookups> {
    const response = await this.backupRequestRepository.getBackupRequestLookups(params);
    return new BackupRequestLookups(response.backupRequestConfig);
  }
}
